import { DeclarationTypes } from "./actionTypes"

//grid

export const getDeclarationListLoading = (lazyState: any) => {
  return {
    type: DeclarationTypes.GET_DECLARATION_LOADING,
    lazyState
  }
}

export const getDeclarationListSuccess = (invoice: any) => {
  return {
    type: DeclarationTypes.GET_DECLARATION_SUCCESS,
    payload: invoice
  }
}

export const getDeclarationListError = (error: any) => {
  return {
    type: DeclarationTypes.GET_DECLARATION_FAIL,
    payload: error
  }
}

export const getManufacturerDropdownLoading = () => {
  return {
    type: DeclarationTypes.GET_MANUFACTURER_DROPDOWN_LOADING,
  }
}

export const getManufacturerDropdownSuccess = (data: any) => {
  return {
    type: DeclarationTypes.GET_MANUFACTURER_DROPDOWN_SUCCESS,
    payload: data
  }
}

export const getManufacturerDropdownError = (error: any) => {
  return {
    type: DeclarationTypes.GET_MANUFACTURER_DROPDOWN_FAIL,
    payload: error
  }
}

export const getDeclarationFormByIdLoading = (id:any) => {
  return {
    type: DeclarationTypes.GET_DECLARATION_BY_ID_LOADING,
    payload:id
  }
}

export const getDeclarationFormByIdSuccess = (data: any) => {
  return {
    type: DeclarationTypes.GET_DECLARATION_BY_ID_SUCCESS,
    payload: data
  }
}

export const getDeclarationFormByIdError = (error: any) => {
  return {
    type: DeclarationTypes.GET_DECLARATION_BY_ID_FAIL,
    payload: error
  }
}

export const createDeclarationFormLoading = (payload:any,id:any=0) => {
  return {
    type: DeclarationTypes.CREATE_DECLARATION_FORM_LOADING,
    payload:{data:payload,id:id}
  }
}

export const createDeclarationFormSuccess = (data: any) => {
  debugger
  return {
    type: DeclarationTypes.CREATE_DECLARATION_FORM_SUCCESS,
    payload: data
  }
}

export const createDeclarationFormError = (error: any) => {
  return {
    type: DeclarationTypes.CREATE_DECLARATION_FORM_FAIL,
    payload: error
  }
}

export const printDeclarationFormLoading = (id:any) => {
  return {
    type: DeclarationTypes.PRINT_DECLARATION_FORM_LOADING,
    payload:id
  }
}

export const printDeclarationFormSuccess = (data: any) => {
  debugger
  return {
    type: DeclarationTypes.PRINT_DECLARATION_FORM_SUCCESS,
    payload: data
  }
}

export const printDeclarationFormError = (error: any) => {
  return {
    type: DeclarationTypes.PRINT_DECLARATION_FORM_FAIL,
    payload: error
  }
}

export const mailDeclarationFormLoading = (id:any) => {
  return {
    type: DeclarationTypes.MAIL_DECLARATION_FORM_LOADING,
    payload:id
  }
}

export const mailDeclarationFormSuccess = (data: any) => {
  debugger
  return {
    type: DeclarationTypes.MAIL_DECLARATION_FORM_SUCCESS,
    payload: data
  }
}

export const mailDeclarationFormError = (error: any) => {
  return {
    type: DeclarationTypes.MAIL_DECLARATION_FORM_FAIL,
    payload: error
  }
}

export const clearDeclarationMessage = () => {
  return {
    type: DeclarationTypes.CLEAR_MESSAGE,
  }
}

export const resetDeclarationMessage = () => {
  return {
    type: DeclarationTypes.RESET_MESSAGE,
  }
}
